import React from 'react';

interface TextCapitalizationButtonsProps {
  currentText: string;
  onTextChange: (newText: string, transformFn?: (text: string) => string) => void;
  containerStyle?: React.CSSProperties;
  buttonStyle?: React.CSSProperties;
}

/**
 * Reusable Text Capitalization Component
 * Provides three buttons: TT (uppercase), Tt (title case), tt (lowercase)
 */
const TextCapitalizationButtons: React.FC<TextCapitalizationButtonsProps> = ({
  currentText,
  onTextChange,
  containerStyle,
  buttonStyle
}) => {
  const handleUpperCase = () => {
    console.log('=== handleUpperCase ===');
    console.log('currentText:', currentText);
    const transformFn = (text: string) => text.toUpperCase();
    const transformed = currentText.toUpperCase();
    console.log('transformed:', transformed);
    console.log('transformFn:', transformFn.toString());
    onTextChange(transformed, transformFn);
  };

  const handleTitleCase = () => {
    console.log('=== handleTitleCase ===');
    console.log('currentText:', currentText);
    const transformFn = (text: string) => text.replace(/\w\S*/g, (txt) => 
      txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    );
    const transformed = transformFn(currentText);
    console.log('transformed:', transformed);
    console.log('transformFn:', transformFn.toString());
    onTextChange(transformed, transformFn);
  };

  const handleLowerCase = () => {
    console.log('=== handleLowerCase ===');
    console.log('currentText:', currentText);
    const transformFn = (text: string) => text.toLowerCase();
    const transformed = currentText.toLowerCase();
    console.log('transformed:', transformed);
    console.log('transformFn:', transformFn.toString());
    onTextChange(transformed, transformFn);
  };

  const defaultContainerStyle: React.CSSProperties = {
    border: '1px solid #555',
    borderRadius: '8px',
    padding: '8px',
    backgroundColor: '#2a2a2a',
    display: 'flex',
    gap: '6px',
    ...containerStyle
  };

  const defaultButtonStyle: React.CSSProperties = {
    padding: '8px 16px',
    backgroundColor: '#3a3a3a',
    border: '1px solid #555',
    borderRadius: '6px',
    color: 'white',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    transition: 'all 0.2s ease',
    ...buttonStyle
  };

  const handleButtonHover = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.currentTarget.style.backgroundColor = '#4a4a4a';
    e.currentTarget.style.borderColor = '#666';
  };

  const handleButtonLeave = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.currentTarget.style.backgroundColor = '#3a3a3a';
    e.currentTarget.style.borderColor = '#555';
  };

  return (
    <div style={defaultContainerStyle}>
      <button
        onClick={handleUpperCase}
        style={defaultButtonStyle}
        onMouseEnter={handleButtonHover}
        onMouseLeave={handleButtonLeave}
        title="All Uppercase"
      >
        TT
      </button>
      <button
        onClick={handleTitleCase}
        style={defaultButtonStyle}
        onMouseEnter={handleButtonHover}
        onMouseLeave={handleButtonLeave}
        title="Title Case"
      >
        Tt
      </button>
      <button
        onClick={handleLowerCase}
        style={defaultButtonStyle}
        onMouseEnter={handleButtonHover}
        onMouseLeave={handleButtonLeave}
        title="All Lowercase"
      >
        tt
      </button>
    </div>
  );
};

export default TextCapitalizationButtons;
